module.exports = __webpack_public_path__ + "img/progress-rounded-light.5b105dd6.svg";